import React from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { getUnreadMessages } from '../App/utils';
var DEFAULT_ICON = 'https://static.finect.com/favicon.ico';
var UNREAD_ICON = 'https://static.finect.com/img/icons/favicon-pip.ico';
var mapStateToProps = function mapStateToProps(state) {
  return {
    conversations: state.conversations.items
  };
};
var FaviconMetatags = function FaviconMetatags(_ref) {
  var conversations = _ref.conversations;
  var unread = getUnreadMessages(conversations);
  var url = unread ? UNREAD_ICON : DEFAULT_ICON;
  return React.createElement(Helmet, null, React.createElement("link", {
    rel: "icon",
    href: url,
    type: "image/x-icon"
  }));
};
export default connect(mapStateToProps, null)(FaviconMetatags);